import { MenuItem } from "@mui/material";
import { useState } from "react";
import { getFechaMasReciente } from "../../../../utils/datetimeUtils";
import FormikActions from "../../../commons/formik/formikActions";
import FormikCheckbox from "../../../commons/formik/formikCheckbox";
import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextFieldSpeech from "../../../commons/formik/formikTextFieldSpeech";
import { StyledCommonForms } from "../../../styled/form";
import DropZone from "../dropZone/dropZone";
import FormSectionDivider from "../formSectionDivider";
import { fpaValidation, validateRequiredFields } from "../formValidation";
import ProfessionalControl from "../professionalControl/professionalControl";
import FpaAppointment from "./fpaAppointment";
import PrestacionesContainer from "./prestacionesContainer";

const Fpa = ({
  handleClose,
  files,
  setFiles,
  handleSubmit,
  model,
  formValues,
  prestaciones,
  setPrestaciones,
  selectedDocument,
  isView,
  disabled,
  idArt,
  idSiniestro,
  trabajador,
  lastProfessionalInfo,
}) => {
  const [attachmentError, setAttachmentError] = useState(false);
  const [professionalError, setProfessionalError] = useState(false);

  const fields = model.fields;

  const fechaHoraPedidoMinDate =
    fields.fechaHoraPedido.validations &&
      fields.fechaHoraPedido.validations.minDate
      ? getFechaMasReciente(
        fields.fechaHoraPedido.validations.minDate,
        fields.fechaPrimeraCuracion.options,
      )
      : fields.fechaPrimeraCuracion.options;
  return (
    <FormikForm
      artFields={fields}
      initialValues={formValues}
      validationSchema={() => fpaValidation(fechaHoraPedidoMinDate)}
      validate={(values) => {
        const errors = validateRequiredFields(values, fields);
        if (!fields.prestaciones.validations.prestadorPrestacional &&
          model.configuration.minAmountOfPrestaciones !== 0 &&
          prestaciones.length < model.configuration.minAmountOfPrestaciones) {
          errors.prestaciones = "Requerido"
        }
        if (model.configuration.requiresAttachment && files.length === 0) {
          errors.attachment = "Adjunto requerido";
          setAttachmentError(true);
        }
        return errors;
      }}
      onSubmit={(values) => {
        if (!professionalError) {
          handleSubmit(values);
        }
      }}>
      {({ values, setFieldValue }) => (
        <StyledCommonForms.FormContainer>

          <StyledCommonForms.FieldContainer>
            <FormSectionDivider title="Autorización" />
            {model.configuration.showTypeFormCombo && (
              <StyledCommonForms.RowContainer>
                <FormikSelect
                  name="nombreTipoFormulario"
                  label={`Tipo de Formulario Especifico ${fields.nombreTipoFormulario.required ? "*" : ""
                    }`}
                  value={formValues.nombreTipoFormulario}
                  variant="outlined"
                  sx={StyledCommonForms.input}
                  disabled={disabled}>
                  {fields.tiposFormulario.options.map((f) => {
                    return (
                      <MenuItem key={f.nombre} value={f.nombre}>
                        {f.formulario} - {f.nombre}
                      </MenuItem>
                    );
                  })}
                </FormikSelect>
              </StyledCommonForms.RowContainer>
            )}
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikDateTimePicker
                  name="fechaHoraPedido"
                  label={`Fecha Hora ${fields.fechaHoraPedido.required ? "*" : ""
                    }`}
                  disableFuture
                  inputVariant="outlined"
                  sx={StyledCommonForms.input}
                  disabled={disabled}
                  minDate={fechaHoraPedidoMinDate}
                  autoComplete="off"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikCheckbox
                  name="enInstitucionPropia"
                  label={`A realizarse en esta institución ${fields.enInstitucionPropia.required ? "*" : ""
                    }`}
                  labelPlacement="end"
                  disabled={disabled}
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>

            <StyledCommonForms.RowContainer>
              <FormikTextFieldSpeech
                id="detalleAutorizacion"
                name="detalleAutorizacion"
                label={`Detalle autorización ${fields.detalleAutorizacion.required ? "*" : ""
                  }`}
                type="text"
                variant="outlined"
                multiline
                minRows={3}
                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikTextFieldSpeech
                id="planTerapeutico"
                name="planTerapeutico"
                label={`Plan terapéutico ${fields.planTerapeutico.required ? "*" : ""
                  }`}
                type="text"
                variant="outlined"
                multiline
                minRows={3}
                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <FormSectionDivider title="Diagnóstico" />
            <StyledCommonForms.RowContainer>
              <FormikTextFieldSpeech
                id="diagnostico"
                name="diagnostico"
                label={`Diagnóstico ${fields.diagnostico.required ? "*" : ""}`}
                type="text"
                variant="outlined"
                multiline
                minRows={3}

                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            {model.configuration.addAppointmentControl && (
              <>
                <FormSectionDivider title="Turnos" />
                <StyledCommonForms.RowContainer>
                  <FpaAppointment
                    idArt={idArt}
                    idSiniestro={idSiniestro}
                    trabajador={trabajador}
                    disabled={disabled}
                    artFields={fields}
                    preloadedProfessional={values.profesionalApellidoNombre || lastProfessionalInfo.profesionalApellidoNombre}
                    preloadedMnMd={values.profesionalMnMp || lastProfessionalInfo.matricula}
                    preloadedSpecialty={values.especialidadInforme || lastProfessionalInfo.especialidadInforme}
                  />
                </StyledCommonForms.RowContainer>
              </>
            )}

            {model.configuration.showPrestaciones &&
              !fields.prestaciones.validations.prestadorPrestacional && (
                <div>
                  <FormSectionDivider title="Prestaciones" />
                  <StyledCommonForms.RowContainer>
                    <PrestacionesContainer
                      name="prestaciones"
                      prestaciones={prestaciones}
                      setPrestaciones={setPrestaciones}
                      disabled={disabled}
                      configuration={model.configuration}
                      idArt={idArt}
                    />
                  </StyledCommonForms.RowContainer>
                </div>
              )}
            <FormSectionDivider title="Profesional" />
            <ProfessionalControl
              disabled={disabled}
              fields={fields}
              setFieldValue={setFieldValue}
              profesionalPreCarga={formValues.profesionalApellidoNombre}
              error={professionalError}
              setError={setProfessionalError}
              especialidadesProfesional={fields.especialidadProfesional}
              values={values}
              habilitarEspecialidadInforme={true}
              isView={isView}
              idArt={idArt}
            />
            {model.configuration.showAttachments && (
              <div>
                <FormSectionDivider title="Adjuntos" />
                <StyledCommonForms.RowContainer>
                  <DropZone
                    files={files}
                    setFiles={setFiles}
                    configuration={model.configuration}
                    error={attachmentError}
                    setError={setAttachmentError}
                    disabled={disabled}
                    selectedDocument={selectedDocument}
                    accept={model.configuration.availableExtensions}
                  />
                </StyledCommonForms.RowContainer>
              </div>
            )}
          </StyledCommonForms.FieldContainer>
          <StyledCommonForms.ActionsContainer>
            <FormikActions handleCancel={handleClose} disabled={disabled} />
          </StyledCommonForms.ActionsContainer>
        </StyledCommonForms.FormContainer>
      )}
    </FormikForm>
  );
};

export default Fpa;
